theme.alinga = {};

theme.alinga.footerMenuAccordian = () => {
  if(window.innerWidth <= 749){
    const accordionBtns = document.querySelectorAll(".mobileAccordion .footer__block__title");

    accordionBtns.forEach((accordion) => {
      accordion.onclick = function () {
        this.classList.toggle("active");

        let content = this.nextElementSibling;
        console.log(content);

        if (content.style.maxHeight) {
          content.style.maxHeight = null;
          console.log(content.scrollHeight);
        } else {
          content.style.maxHeight = content.scrollHeight + "px";
          console.log(content.style.maxHeight);
        }
      };
    });
  }
}

theme.alinga.sizeChartPopup = () => {
  let triggerValue = document.querySelector('.size-chart-trigger');
  if(triggerValue){
    let targetValue = document.querySelector('.size-chart-popup-wrapper');
    triggerValue.addEventListener('click', function(){
      if(targetValue.classList.contains("active")){
        targetValue.classList.remove("active");
      }else{
         targetValue.classList.add("active");
      }
    })
    let sizeChartValue =  document.querySelector('.size-chart-popup-wrapper .handle-svg')
    sizeChartValue.addEventListener('click', function () {	    
      if(targetValue.classList.contains("increase--chart")){
        targetValue.classList.remove("increase--chart");
      }else {
        targetValue.classList.add("increase--chart"); 
      }	
    })
    let bodyClass = document.querySelector('.template-product');
     triggerValue.addEventListener('click', function(){
        bodyClass.classList.add("no-scrollbar");
     })
    let removeValue = document.querySelector('.product-modal__close');
    removeValue.addEventListener('click', function (){
      if(targetValue.classList.contains("active")){
       targetValue.classList.remove("active");
      }
      if(targetValue.classList.contains("increase--chart")){
        targetValue.classList.remove("increase--chart");
      }
      if(bodyClass.classList.contains("no-scrollbar")){
        bodyClass.classList.remove("no-scrollbar");
      }
    })
    let bodyClassRemove = document.querySelector('.product-modal__overlay');
    bodyClassRemove.addEventListener('click', function(){
      bodyClass.classList.remove("no-scrollbar");
      targetValue.classList.remove("active");
    })
  }
}

theme.alinga.sizeChartTableHover = () => {
  let tableRow = document.querySelectorAll('.sc-table tr');
  let tableHeader = document.querySelectorAll('.sc-table tr th');
  let tableDetail = document.querySelectorAll('.sc-table tr td');
  let tableMain = document.querySelectorAll('.sc-table .sc-header');
  let tableMainRow = document.querySelectorAll('.sc-table .sc-header th');
  
  tableRow.forEach((tablerow) => {
    tablerow.addEventListener('mouseover', function() {
      this.classList.add("highlight");
    });
    tablerow.addEventListener('mouseout', function() {
      this.classList.remove("highlight");
    });
  });
  tableHeader.forEach((tableheader) => {
    tableheader.addEventListener('mouseover', function(){
      this.classList.add("activeCell");
    });
    tableheader.addEventListener('mouseout', function(){
      this.classList.remove("activeCell");
    });
  });
  tableDetail.forEach((tabledetail) => {
    tabledetail.addEventListener('mouseover', function(){
      const data_index = this.dataset.index;
      $('.sc-table tr td[data-index='+data_index+']').addClass("highlight");
      this.classList.add("activeCell");
      //this.classList.add("highlight");
    });
    tabledetail.addEventListener('mouseout', function(){
      const data_index = this.dataset.index;
      $('.sc-table tr td[data-index='+data_index+']').removeClass("highlight");
      this.classList.remove("activeCell");
      //this.classList.remove("highlight");
    });
  });
  tableMain.forEach((tablemain) => {
    tablemain.addEventListener('mouseover', function(){
      this.classList.remove("highlight");
    });  
  });
  tableMainRow.forEach((tablemainrow) => {
    tablemainrow.addEventListener('mouseover', function(){
      const data_index = this.dataset.index;
      $('.sc-table tr td[data-index='+data_index+']').addClass("highlight");
      //this.classList.add("highlight");
    })
    tablemainrow.addEventListener('mouseout', function(){
      const data_index = this.dataset.index;
      $('.sc-table tr td[data-index='+data_index+']').removeClass("highlight");
      //this.classList.remove("highlight");
    });
  });

}

// theme.alinga.sizeChartPopup = () => {
//   let triggerValue = document.querySelector('.size-chart-trigger');
//   let targetValue = document.querySelector('.size-chart-popup-wrapper');
//     let closePopup = document.querySelector('.close-icon-svg');
//   triggerValue.onclick = function(){
//     targetValue.classList.add('active');
//     document.querySelector('.template-product').classList.add('no-scrollbar');
//   }
//   closePopup.onclick = function(){
//     targetValue.classList.remove('active');
//     document.querySelector('.template-product').classList.remove('no-scrollbar');
//   }
// }
 
document.addEventListener('DOMContentLoaded', () => {
  theme.alinga.footerMenuAccordian();
  theme.alinga.sizeChartPopup();
  theme.alinga.sizeChartTableHover();
});

$('.modal-toggle').on('click', function(e) {
  e.preventDefault();
  var id = $(this).attr("data-id");
  $('.modal-data-'+id).toggleClass('is-visible');
});